import React from "react";

import Popup from "./Popup";
import InputControlledMask from "./Forms/InputControlledMask";

import { useForm } from "react-hook-form";
import { useHttp } from "../hooks/useHttp";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { CButton } from "@coreui/react";
import { useMutation } from "@tanstack/react-query";

const advancedSearchSchema = yup.object({
  email: yup.string().email(),
  cpf: yup.string()
});

const PopupAdvancedSearchProspect = props => {
  const { trigger, setTrigger } = props;

  const request = useHttp();

  /**
   *
   *
   *
   */
  const { handleSubmit: handleSubmitAdvancedSearch, control: controlAdvancedSearch, reset: resetAdvancedSearch, formState: { errors: errorsAdvancedSearch } } = useForm({
    resolver: yupResolver(advancedSearchSchema)
  });

  const mutation = useMutation(["advanced-search"], ({ email, cpf }) => request({ url: `/users/search/prospect?email=${email}&cpf=${cpf}`, method: "GET" }), {
    onSuccess: res => {
      console.log(res);
    }
  });

  const handleAdvancedSearch = (data) => {
    console.log(data);
    mutation.mutate({ email: data.email, cpf: data.cpf });
  };

  // https://testedati.sa.ngrok.io/api/users/search/prospect?email=&cpf=
  //

  React.useEffect(() => {
    resetAdvancedSearch();
  }, [trigger]);

  return (
    <Popup title="Pesquisa avançada" trigger={trigger} setTrigger={setTrigger} width="420">
      <div className="x-p-20">
        {(mutation.data?.data && !mutation.isLoading) && <div className="text-color mt-10">{mutation.data?.data.message}</div>}
        <form onSubmit={handleSubmitAdvancedSearch(handleAdvancedSearch)}>
          <InputControlledMask label="E-mail" type="text" placeholder="E-mail" name="email" error={errorsAdvancedSearch.email} control={controlAdvancedSearch} />
          <InputControlledMask label="Cpf" type="text" placeholder="Cpf" name="cpf" error={errorsAdvancedSearch.cpf} control={controlAdvancedSearch} />
          <div className="d-flex flex-row justify-content-between mt-20 mb-20">
            <div></div>
            <div>
              <CButton color="danger" variant="ghost" onClick={() => setTrigger(false)}>Cancelar</CButton>
              <CButton type="submit" color="primary" className="ml-10">
                {mutation.isLoading ? "Carregando..." : "Pesquisar"}
              </CButton>
            </div>
          </div>
        </form>
      </div>
    </Popup>
  );
}

export default PopupAdvancedSearchProspect;